import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Hero } from "../components/Hero";
import { Dedication } from "../components/Dedication";
import { MemoriesGallery } from "../components/MemoriesGallery";
import { ConcertSpotlight } from "../components/ConcertSpotlight";
import { BookPreview } from "../components/BookPreview";
import { WishesBoard } from "../components/WishesBoard";

export default function Landing() {
  useEffect(() => {
    document.title = "happy birthday tina";
  }, []);

  return (
    <div data-testid="landing-page">
      <nav className="fixed inset-x-0 top-0 z-40 flex items-center justify-between bg-[#FAF6EE]/70 px-6 py-4 backdrop-blur-md sm:px-10">
        <span className="font-hand text-2xl text-[#C87D87]">for tina</span>
        <div className="flex items-center gap-6 text-xs font-semibold">
          <a href="/" data-testid="nav-landing-link" className="text-[#4A2E35]/70 transition-colors hover:text-[#4A2E35]">Home</a>
          <Link
            to="/read"
            data-testid="nav-read-link"
            className="rounded-full bg-[#4A2E35] px-4 py-2 text-[#FAF6EE] transition-colors hover:bg-[#362428]"
          >
            Open the Book
          </Link>
        </div>
      </nav>
      <Hero />
      <Dedication />
      <MemoriesGallery />
      <ConcertSpotlight />
      <BookPreview />
      <WishesBoard />
      <footer className="px-6 pb-12 pt-6 text-center">
        <p className="font-hand text-2xl text-[#C87D87]">happy twentieth, tina lang chicken wang</p>
      </footer>
    </div>
  );
}
